import { render, staticRenderFns } from "./WeekOverviewCard.vue?vue&type=template&id=033a8b54&scoped=true&"
import script from "./WeekOverviewCard.vue?vue&type=script&lang=js&"
export * from "./WeekOverviewCard.vue?vue&type=script&lang=js&"
import style0 from "./WeekOverviewCard.vue?vue&type=style&index=0&id=033a8b54&lang=scss&scoped=true&"
import style1 from "./WeekOverviewCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033a8b54",
  null
  
)

export default component.exports